module.exports = __webpack_public_path__ + "img/apple-store.a4172674.png";